import { compose, withProps, withState, withHandlers } from "recompose";
import { requestApi } from "core/api";
import * as paymentApi from "modules/payment/api";
import * as paymentSelectors from "modules/payment/selectors";
import * as hoc from "modules/user/auth/hoc";
import { isInsider } from "modules/user/auth/model";
import { fetchApi } from "core/api/hoc";
import View from "./View";
import * as userSelectors from "modules/user/auth/selectors";
import * as profileSelectors from "modules/user/profile/selectors";
import * as insiderSelectors from "modules/insiders/selectors";
import { connect } from "react-redux";
import { createErrorsSelector } from "core/helpers";
import { createStructuredSelector } from "reselect";
import * as insiderProfileApi from "modules/user/profile/api";
import * as insiderApi from "modules/insiders/api";
import yup from "yup";

export default compose(
  hoc.authorized(isInsider),
  fetchApi(paymentApi.billingInfo, {
    key: "paymentInfo",
    selector: paymentSelectors.billingInfoApi,
    sync: true
  }),
  connect(
    createStructuredSelector({
      accountBalance: paymentSelectors.billingAccountBalanceApi
    })
  ),
  fetchApi(insiderApi.getCountries, () => ({
    selector: insiderSelectors.getCountriesApi,
    sync: true,
    key: "countries"
  })),
  fetchApi(insiderApi.getPositions, {
    key: "positionsInfo",
    selector: insiderSelectors.getPositionsApi,
    sync: true
  }),
  fetchApi(insiderApi.getAvailabilities, () => ({
    selector: insiderSelectors.getAvailabilitiesApi,
    sync: true,
    key: "availabilities"
  })),
  withProps({
    positionInitialValue: {
      company_name: "",
      title_name: "",
      country: "United States of America",
      city: "",
      is_main_position: false
    },
    availabilityInitialValue: {
      day: "",
      grace_period: 1,
      time_zone: "",
      time_start: "",
      time_end: ""
    },
    profileValidationSchema: yup.object().shape({
      first_name: yup.string().required("First name is required"),
      last_name: yup.string().required("Last name is required"),
      phone: yup
        .string()
        .required("Phone is required")
        .matches(/^[+][0-9]/, {
          message: "Please, Enter a correct phone number",
          excludeEmptyString: true
        })
        .nullable()
    }),
    positionValidationSchema: yup.object().shape({
      company_name: yup.string().required("Company is required"),
      title_name: yup.string().required("Role is required"),
      country: yup.string().required("Country is required"),
      city: yup.string().required("City is required")
    }),
    availabilityValidationSchema: yup.object().shape({
      day: yup.string().required("Day is required"),
      time_zone: yup.string().required("Timezone is required"),
      time_start: yup.string().required("Time Start is required"),
      time_end: yup.string().required("Time End is required")
    })
  }),
  connect(
    createStructuredSelector({
      profileInitialValues: userSelectors.fetchUserData,
      positionsInitialValues: insiderSelectors.getPositionsApi,
      availabilitiesInitialValues: insiderSelectors.getAvailabilitiesApi,
      profileErrors: createErrorsSelector(profileSelectors.editProfile),
      positionsErrors: createErrorsSelector(insiderSelectors.getPositionsApi),
      availabilitiesErrors: createErrorsSelector(
        insiderSelectors.getAvailabilitiesApi
      ),
      updateAvatarApi: profileSelectors.updateAvatar,
      editApi: profileSelectors.editProfile,
      addPositionsApi: insiderSelectors.addPositionsApi,
      addAvailabilityApi: insiderSelectors.addAvailabilityApi
    }),
    dispatch => ({
      onSubmitProfile: ({ ...values }, { setErrors }) => {
        return dispatch(
          insiderProfileApi.editProfile.request({ body: values })
        );
      },
      onSubmitAvatar: values => {
        return dispatch(
          insiderProfileApi.updateAvatar.request({ photo: values.photo })
        );
      },
      onSubmitPositions: ({ ...values }, { setErrors }) => {
        return dispatch(
          insiderApi.addPositions.request({
            body: [{ ...values, is_main_position: false }]
          })
        );
      },
      onSubmitAvailability: ({ ...values }, { setErrors }) => {
        return dispatch(
          insiderApi.addAvailability.request({
            body: [{ ...values }]
          })
        );
      },
      onDeletePositionClick: id => {
        return dispatch(insiderApi.deletePosition.request(id));
      },
      onDeleteAvailabilityClick: id => {
        return dispatch(insiderApi.deleteAvailability.request(id));
      }
    })
  ),
  withProps({
    companySearchRequest: query =>
      requestApi({
        path: `/insiders/professional-info-lookup/`,
        method: "POST",
        body: {
          company_lookup: query
        }
      }),
    roleSearchRequest: query =>
      requestApi({
        path: `/insiders/professional-info-lookup/`,
        method: "POST",
        body: {
          title_lookup: query
        }
      })
  }),
  withState("companies", "setCompanies", []),
  withState("roles", "setRoles", []),
  withHandlers({
    fetchCompanies: ({ setCompanies, companySearchRequest }) => async value => {
      const res = await companySearchRequest(value);
      setCompanies(
        res.companies.map((title, i) => ({
          id: i,
          title
        }))
      );
    },
    fetchRoles: ({ setRoles, roleSearchRequest }) => async value => {
      const res = await roleSearchRequest(value);
      setRoles(
        res.titles.map((title, i) => ({
          id: i,
          title
        }))
      );
    }
  })
)(View);



// WEBPACK FOOTER //
// ./src/components/pages/Insider/Profile/Provider.js